// extracted by mini-css-extract-plugin
module.exports = {"popUp":"ModalPopUp_popUp__2lEKi","shadow":"ModalPopUp_shadow__1lUVK","rounded":"ModalPopUp_rounded__1s5Fj"};